import React, { useState, useEffect } from 'react';
import dataProvider from '../../lib/dataProvider';
import { useTranslate, usePermissions } from 'react-admin';
import { Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, 
  CardContent, TextField, Checkbox } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CheckRecht } from '../../lib/globalData';
import get from 'lodash/get';
import moment from 'moment';
import 'moment/dist/locale/de';

const RepBfs = () => {
  const tr = useTranslate();
  const [ dialog, setDialog ] = useState('')
  const [ send_bfs2020, setSend_bfs2020 ] = useState(true)
  const [ rec, setRec ] = useState({id:0, hostel:'', login_name:'', hostel_nummer:'', info:{RoomForDisabled: false, ContactName: '', ContactPhone: '', ContactEMail: '', NextClosingFrom: '', NextClosingTo: '', TotalOpenDays: '' }})
  const { permissions } = usePermissions();
  const recht = permissions?permissions.reduce((res, r)=>{return r.route==='repBfs'?r.recht:res}, -1):0;
  
  moment.locale('de');

  const getRecord = () => {
    dataProvider.getOne('repBfs', {id:0})
    .then(res  => {
      setRec(res.data)
    })
  }

  useEffect(() => {
    getRecord()
  }, []);

  const updateBur = () => {
    if(rec.id > 0){
      dataProvider.update('repBfs', {id: rec?.id, data: rec})
      .then(res  => {
        //console.log(res)
        getRecord()
      })
    }
  }

  const handleCheck = (send=false) => {
    if(rec.id > 0){
      rec.check = true
      rec.dosend = send
      dataProvider.update('repBfs', {id: rec?.id, data: rec})
      .then(res  => {
        if(!res.data?.bfs){
          setDialog({msg: res.data})
        }
        else {
          setDialog({...res.data.bfs, ...{xml: res.data.xml}})
        }
        //console.log(res)
      })
    }
  }

  const handleUpdInfo = (fld, val) => {
    var r = {...rec}
    r.info[fld] = val
    //console.log(r)
    setRec(r)
  }

  const DialogField = ({source}) => {
    const tr = useTranslate();
    var value = get(dialog, source, '');
    if(value === false)value = 0
    if(value === true)value = 1
    return (
      <div style={{ display: 'flex', gap: '1em' }}>
        <div className="lcont">{tr('bw.rep.bfs.dialog.'+source)}: </div>
        <div className="lcont">{value}</div>
      </div>
    )
  }
  
  const StatField = ({source}) => {
    const value = get(dialog, source, '')
    return (
      <div style={{ display: 'flex', gap: '1em' }}>
        <div className="lcont">{value?.country} </div>
        <div className="fcont">{value?.arrivals}</div>
        <div className="fcont">{value?.nights}</div>
      </div>
    )
  }
  
  const DialogStat = () => {
    const value = get(dialog, 'myData', '');
    const stat = []
    Object.keys(value).forEach((key) => {stat.push(<StatField key={'sf_'+key} source={"myData."+key} />)})
    return (
      <>
        <div style={{ display: 'flex', gap: '1em', marginTop: '.7em' }}>
          <div className="lcont"><b>Country</b></div>
          <div className="fcont"><b>Arrivals</b></div>
          <div className="fcont"><b>Nights</b></div>
        </div>
        <div>
          { stat }
          <StatField source={"total"} />
        </div>
      </>
    )
  }

  //console.log(["rerender", rec])
  
  return (        
    <Paper style={{scroll:'auto'}} >
      <CardContent sx={{ "& .lcont": { margin:"0.3em 0", width: '10em' }, "& .l2cont": { margin:"0.7em 0", width: '20em' }, "& .fcont": { margin:"0.3em 0" } }} >
        <div style={{ display: 'flex', gap: '1em' }}>
          <div className="lcont">Hostel: </div>
          <div className="fcont">{rec?.hostel}</div>
        </div>
        <div style={{ display: 'flex', gap: '1em' }}>
          <div className="lcont">Login: </div>
          <div className="fcont">{rec?.login_name}</div>
        </div>
        <div style={{ display: 'flex', gap: '1em' }}>
          <div className="lcont">BUR-Number: </div>
          <TextField source="hostel_nummer" value={rec?.hostel_nummer} size="small" variant="standard" sx={{ width: '10em', mr: '2em', mt: '0.3em' }} onChange={(ev)=>{ setRec({ ...rec, hostel_nummer: ev.target.value }) }} disabled={recht<10} />
          <CheckRecht route="repBfs" level={10} >
            <Button onClick={()=>updateBur()} variant="contained" sx={{ textDecoration: 'none', width: '14em' }}>
              {tr('glob.save')}
            </Button>
          </CheckRecht>
        </div>

        { rec?.hostel_nummer !== '' && 
          <div style={{ display: 'flex', gap: '1em', marginTop:'2em' }}>
            <Checkbox checked={send_bfs2020} source="send_bfs2020" onChange={() => setSend_bfs2020(!send_bfs2020)} sx={{ p: 0 }} />
            <div>BFS HESTA (Switzerlang) <b>ab 2020</b></div>
          </div>
        }
        { rec?.hostel_nummer === '' && 
          <div style={{marginTop: '2em', fontWeight: 'bold'}}>{tr('bw.rep.bfs.noBur')}</div>
        }
        { rec?.hostel_nummer !== '' && send_bfs2020 === true && <>
          <hr />
          <LocalizationProvider dateAdapter={AdapterMoment} >
            <>
            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">{tr('bw.rep.bfs.month')}</div>
              <DatePicker label='' value={moment(rec?.info?.Period)} views={['year', 'month']}
                onChange={(ev) => {handleUpdInfo('Period', ev.format('YYYY-MM'))} }
                sx={{mt: 0, mb: 0, width: '15em',
                '& .MuiInputBase-root': { height: '40px', padding: '0 14px' },
                '& .MuiFilledInput-input': { padding: '0 0px', fontSize: '1.2em' },
                '& .MuiInput-underline:before': { borderBottom: 'none' },
                '& .MuiInput-underline:after': { borderBottom: 'none' },
                '& .MuiInput-underline': { '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' }}, }}
              />
            </div>
            
            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">{tr('bw.rep.bfs.RoomForDisabled')}</div>
              <div className="fcont">
                <Checkbox checked={rec?.info?.RoomForDisabled} source="RoomForDisabled" onChange={(ev)=>handleUpdInfo('RoomForDisabled', ev.target.checked)} sx={{ p: '0.3em 0' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">{tr('bw.rep.bfs.ContactName')}</div>
              <div className="fcont">
                <TextField source="ContactName" value={rec?.info?.ContactName} hiddenLabel size="small" variant="filled" sx={{ width: '15em', mr: '2em', mt: '0' }} onChange={(ev)=>handleUpdInfo('ContactName', ev.target.value)}  />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">{tr('bw.rep.bfs.ContactPhone')}</div>
              <div className="fcont">
                <TextField source="ContactPhone" value={rec?.info?.ContactPhone} hiddenLabel size="small" variant="filled" sx={{ width: '15em', mr: '2em', mt: '0' }} onChange={(ev)=>handleUpdInfo('ContactPhone', ev.target.value)}  />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">{tr('bw.rep.bfs.ContactEMail')}</div>
              <div className="fcont">
                <TextField source="ContactEMail" value={rec?.info?.ContactEMail} hiddenLabel size="small" variant="filled" sx={{ width: '15em', mr: '2em', mt: '0' }} onChange={(ev)=>handleUpdInfo('ContactEMail', ev.target.value)}  />
              </div>
            </div>
            
            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">{tr('bw.rep.bfs.NextClosingFrom')}</div>
              <DatePicker label='' value={moment(rec?.info?.NextClosingFrom)} views={['year', 'month', 'day']}
                onChange={(ev) => {handleUpdInfo('NextClosingFrom', ev.format('YYYY-MM-DD'))} }
                sx={{mt: 0, mb: 0, width: '15em',
                '& .MuiInputBase-root': { height: '40px', padding: '0 14px' },
                '& .MuiFilledInput-input': { padding: '0 0px', fontSize: '1.2em' },
                '& .MuiInput-underline:before': { borderBottom: 'none' },
                '& .MuiInput-underline:after': { borderBottom: 'none' },
                '& .MuiInput-underline': { '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' }}, }}
              />
              <Button onClick={()=>handleUpdInfo('NextClosingFrom', '')} size='small' variant="text" sx={{ textDecoration: 'none' }}>
                {tr('bw.rep.bfs.clear')}
              </Button>
            </div>
            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">{tr('bw.rep.bfs.NextClosingTo')}</div>
              <DatePicker label='' value={moment(rec?.info?.NextClosingTo)} views={['year', 'month', 'day']}
                onChange={(ev) => {handleUpdInfo('NextClosingTo', ev.format('YYYY-MM-DD'))} }
                sx={{mt: 0, mb: 0, width: '15em',
                '& .MuiInputBase-root': { height: '40px', padding: '0 14px' },
                '& .MuiFilledInput-input': { padding: '0 0px', fontSize: '1.2em' },
                '& .MuiInput-underline:before': { borderBottom: 'none' },
                '& .MuiInput-underline:after': { borderBottom: 'none' },
                '& .MuiInput-underline': { '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' }}, }}
              />
              <Button onClick={()=>handleUpdInfo('NextClosingTo', '')} size='small' variant="text" sx={{ textDecoration: 'none' }}>
                {tr('bw.rep.bfs.clear')}
              </Button>
            </div>

            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">{tr('bw.rep.bfs.TotalOpenDays')}</div>
              <div className="fcont">
                <TextField source="TotalOpenDays" value={rec?.info?.TotalOpenDays} hiddenLabel size="small" variant="filled" sx={{ width: '15em', mr: '2em', mt: '0' }} onChange={(ev)=>handleUpdInfo('TotalOpenDays', ev.target.value)}  />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '1em' }}>
              <div className="l2cont">
                <Button onClick={()=>handleCheck()} variant="contained" sx={{ textDecoration: 'none', width: '14em' }}>
                  {tr('bw.rep.bfs.check')}
                </Button>
              </div>
              <div className="fcont">
                <Button onClick={()=>handleCheck(true)} variant="contained" sx={{ textDecoration: 'none', width: '14em' }}>
                  {tr('bw.rep.bfs.send')}
                </Button>
              </div>
            </div>
            </>
          </LocalizationProvider>
        </>}
      </CardContent>
      <Dialog open={dialog !== ''} onClose={()=>setDialog('')} >
        <DialogTitle>{tr("bw.rep.bfs.report")} </DialogTitle>
        <DialogContent sx={{ "& .lcont": { margin:"0.2em 0", width: '10em' }, "& .fcont": { margin:"0.2em 0", width: '5em' } }} >
          <div style={{ display: 'flex', gap: '1em', color: 'red', marginBottom: '.8em' }}>
            {dialog?.msg}
          </div>
          <DialogField source="info.Ident" />
          <DialogField source="info.Period" />
          <DialogField source="info.Automatic" />
          <DialogField source="info.RoomForDisabled" />
          <DialogField source="info.ContactName" />
          <DialogField source="info.ContactPhone" />
          <DialogField source="info.ContactEMail" />
          <DialogField source="info.NextClosingFrom" />
          <DialogField source="info.NextClosingTo" />
          <DialogField source="info.TotalOpenDays" />
          <DialogField source="numRoom" />
          <DialogField source="numBed" />
          <DialogField source="TotalOccupiedRooms" />
          <DialogField source="AvgNightIncome" />
          <DialogStat />
          <div style={{ fontFamily: 'monospace', fontSize: '0.8em', marginTop: '1em' }}>{dialog?.xml}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setDialog('')} color="primary">
            <span>{tr("glob.close")}</span>
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>         
  )
}

export default RepBfs;
